var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOut({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1038 13.4946H27.6432M27.6432 13.4946L23.3698 8.28511M27.6432 13.4946L23.3698 18.7041M17.3859 6.98274V4.60461C17.3859 4.24434 17.3123 3.88799 17.1698 3.55809C17.0273 3.22818 16.8189 2.9319 16.5579 2.68795C16.2969 2.44401 15.9889 2.25772 15.6534 2.14085C15.3179 2.02399 14.9622 1.97909 14.6088 2.00899L4.35148 2.87637C3.71047 2.9306 3.11293 3.22755 2.67737 3.70833C2.2418 4.18912 2.00003 4.81862 2 5.47199V21.5172C2.00003 22.1706 2.2418 22.8001 2.67737 23.2808C3.11293 23.7616 3.71047 24.0586 4.35148 24.1128L14.6088 24.9815C14.9623 25.0114 15.3182 24.9665 15.6537 24.8495C15.9893 24.7326 16.2974 24.5462 16.5584 24.3021C16.8194 24.058 17.0277 23.7615 17.1702 23.4315C17.3126 23.1014 17.3861 22.7449 17.3859 22.3846V20.0064",
    stroke: "#5F5F5F",
    strokeWidth: 3.1884,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/signOut.005c057fde8a95c48c469c624130cf83.svg";
export { ForwardRef as ReactComponent };